import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import './SuggestedActionModal.css';

const SuggestedActionModal = ({ notification, action, onClose, onExecute }) => {
  const Maps = useNavigate();
  const { t } = useI18n();

  const handleExecute = () => {
    if (action.type === 'CREATE_TASK') {
      Maps(action.path, { state: { prefilledTask: action.payload } });
    } else if (action.path === '/mutant-box') {
      // Redirigir a Main con el trigger de scroll
      Maps('/', { state: { scrollToMutantBox: true } });
    } else {
      Maps(action.path);
    }

    if (onExecute) onExecute();
    else onClose();
  };

  const originalMessage = typeof notification.message === 'string'
    ? notification.message
    : (notification.title || t('notifications.systemNew'));

  return (
    <div className="suggested-action-overlay">
      <div className="suggested-action-modal">
        <div className="suggested-action-header">
          <h3>{t('notifications.suggestedAction')}</h3>
        </div>
        <div className="suggested-action-body">
          <p className="original-message">"{originalMessage}"</p>
          <div className="action-highlight">
            <h4>{action.title}</h4>
            <p>{action.description}</p>
          </div>
        </div>
        <div className="suggested-action-footer">
          <button className="btn-ignore" onClick={onClose}>{t('notifications.ignore')}</button>
          <button className="btn-execute" onClick={handleExecute}>{t('notifications.executeAction')}</button>
        </div>
      </div>
    </div>
  );
};

export default SuggestedActionModal;
